import { SearchApi } from 'legacy/lut/classes/services/api/SearchApi'

import { Region } from 'clickNgo/configs/geo'

import { IContactSearchRequest } from '../models/contact/contactSearchRequest'
import { ISearchParametersBase } from '../models/search'

interface IMapFiltersToContactSearchParameters extends Omit<ISearchParametersBase, 'user'> {
  region: Region
}

export const mapFiltersToContactSearchParameters = ({
  filters,
  region,
  countries,
}: IMapFiltersToContactSearchParameters): IContactSearchRequest => {
  const country = countries.find((it) => it.name === filters.partner.country)
  const countryISO = country ? country.value : undefined

  return {
    page: filters.pagination.contactsPage,
    pageSize: 10,
    condition: {
      input: filters.search,
      market: filters.common.market !== SearchApi.IN_REGION ? filters.common.market : undefined,
      region,
      contact: {
        ...filters.contact,
        address: {
          countryISO,
          state: filters.partner.state,
          city: filters.partner.city,
          zip: filters.partner.zipCode,
          address: filters.partner.address,
        },
      },
      partner: {
        companyName: filters.partner.isLegal
          ? filters.partner.companyLegalName
          : filters.partner.communicationName,
        taxID: filters.partner.taxId,
        ppid: filters.partner.partnerId,
        email: filters.contact.email,
        locationID: filters.partner.locationId,
        url: filters.partner.url,
      },
    },
  }
}
